export default function(element) {
  element.classList.add('highlighted')

  setTimeout(() => {
    element.classList.remove('highlighted')
  }, 1500)
}
